import { Avatar, Col, Divider, List, Row, Select, Collapse, Badge } from "antd";
import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import { useQueries, useQuery } from "react-query";
import constants from "../../constants";
import useView from "../../hooks/useView";

const fetchBatch = () => {
  const url = `${constants.NEW_DOMAIN}/api/v1/slot/getSlots?slotId:sw=DUBAI`;
  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${process.env.REACT_APP_JWT_TOKEN}`,
    },
  });
};

const fetchUsers = ({ queryKey }) => {
  const batchId = queryKey[1];

  const url = `${constants.NEW_DOMAIN}/api/v1/user/findForSlot/${batchId}`;
  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${process.env.REACT_APP_JWT_TOKEN}`,
    },
  });
};

const Interns = () => {
  const { isMobile } = useView();
  const [batchId, setBatchId] = useState("");

  // query batch
  const {
    data: batchResponse,
    isLoading,
    isError,
    error,
  } = useQuery("batches", fetchBatch, {
    cacheTime: 24 * 60 * 60 * 1000,
    staleTime: 60 * 60 * 1000,
  });

  const { data: userResponse } = useQuery(["user", batchId], fetchUsers, {
    enabled: !!batchId,
    cacheTime: 10 * 60 * 1000,
    staleTime: 5 * 60 * 1000,
    select: (data) => {
      return (data?.data?.data || []).map((userData, idx) => {
        return {
          key: userData?._id || idx,
          name: userData?.userId?.name || "N/A",
          phone: userData?.userId?.phone || "N/A",
          email: userData?.userId?.email || "N/A",
          school: userData?.userId?.profile?.school || "N/A",
          city: userData?.userId?.profile?.city || "N/A",
          age: userData?.userId?.profile?.age || "N/A",
          tasks: Object.keys(userData?.progress?.internship_v1 || {}).reduce((acc, key) => {
            const arr = userData.progress.internship_v1[key];
            acc[key] = Array.isArray(arr) && arr.length ? arr[arr.length - 1] : {};
            return acc;
          }, {}),
        };
      });
    },
  });

  const selectedBatch = (batchResponse?.data?.data || []).find((b) => b._id === batchId);

  return (
    <div style={{ padding: "0 20px" }}>
      {console.log(userResponse)}
      <h1>Select the batch</h1>

      <Select
        style={{ width: 200 }}
        loading={isLoading}
        value={batchId}
        placeholder="Select"
        onChange={(e) => setBatchId(e)}
        options={(batchResponse?.data?.data || []).map((batch) => {
          return { value: batch._id, label: batch.description };
        })}
      />

      {userResponse && selectedBatch && (
        <div style={{ marginTop: 16 }}>
          <Collapse accordion>
            {(selectedBatch.timeLine || []).map((schedule) => {
              const weekId = `week${schedule.id}`;
              const completed = (userResponse || []).filter((u) => u?.tasks?.[weekId]?.description);
              const pending = (userResponse || []).filter((u) => !u?.tasks?.[weekId]?.description);
              const startDate = new Date(schedule.startDate).getTime();
              const endDate = new Date(schedule.endDate).getTime();
              const currTime = Date.now();
              const activeTask = startDate <= currTime && currTime <= endDate;
              const header = (
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                  <span style={{ fontWeight: 600 }}>Day {schedule.id}</span>
                  <span style={{ color: "#16a34a" }}>Completed: {completed.length}</span>
                  <span style={{ color: "#ef4444" }}>Pending: {pending.length}</span>
                  {!isMobile && <span>Start Date : {new Date(schedule.startDate).toDateString()}</span>}
                  {activeTask && <Badge status="processing" size="30" />}
                </div>
              );
              return (
                <Collapse.Panel header={header} key={schedule.id}>
                  <p style={{ color: "gray" }}>Deadline : {new Date(endDate).toLocaleString()}</p>
                  <Row gutter={[12, 12]}>
                    <Col xs={24} md={12}>
                      <div>
                        <h3 style={{ margin: 0, marginBottom: 8 }}>Task completed ({completed.length})</h3>
                        <List
                          size="small"
                          bordered
                          dataSource={completed}
                          renderItem={(item, index) => (
                            <List.Item>
                              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                <div style={{ fontWeight: 200 }}>{item.name}</div>
                              </div>
                            </List.Item>
                          )}
                        />
                      </div>
                    </Col>
                    <Col xs={24} md={12}>
                      <div>
                        <h3 style={{ margin: 0, marginBottom: 8 }}>Pending ({pending.length})</h3>
                        <List
                          size="small"
                          bordered
                          dataSource={pending}
                          renderItem={(item, index) => (
                            <List.Item>
                              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                <div style={{ fontWeight: 500 }}>{item.name}</div>
                              </div>
                            </List.Item>
                          )}
                        />
                      </div>
                    </Col>
                  </Row>
                </Collapse.Panel>
              );
            })}
          </Collapse>
        </div>
      )}
    </div>
  );
};

export default Interns;
